export const wildcard2BundesligaHerren2026 = {
  "id": "wildcard-2-bundesliga-herren-2026-27",
  "title": "Wildcardvergabe für die 2. Rugby Bundesliga der Herren",
  "slug": "wildcard-2-bundesliga-herren-2026-27",
  "publishedAt": "2026-07-03T09:00:00Z",
  "author": "Rugby Deutschland",
  "language": "de",
  "readTime": "2 min",
  "tags": [
    "Rugby",
    "Bundesliga",
    "2. Bundesliga",
    "Wildcard",
    "Lizenzordnung",
    "Saison 2026/27"
  ],
  "excerpt": "Gemäß § 10 der Lizenzordnung von Rugby Deutschland werden für die Saison 2026/2027 jeweils ein vakanter Startplatz in der 2. Rugby Bundesliga Nord/Ost sowie ein vakanter Startplatz in der 2. Rugby Bundesliga Süd/West ausgeschrieben.",
  "img": "/images/wildcard-2-bundesliga-herren-2026-27.jpg",
  "blocks": [
    {
      "type": "paragraph",
      "content": "Gemäß § 10 der Lizenzordnung von Rugby Deutschland werden für die Saison 2026/2027 jeweils ein vakanter Startplatz in der 2. Rugby Bundesliga Nord/Ost sowie ein vakanter Startplatz in der 2. Rugby Bundesliga Süd/West ausgeschrieben. Die Ausschreibung erfolgt aufgrund nicht besetzter Startplätze im Rahmen des Lizenzierungsverfahrens."
    },
    {
      "type": "paragraph",
      "content": "Das Wildcard-Vergabeverfahren startet am 01. Juli 2026 und endet am 10. Juli 2026. Auf eine Wildcard in den beiden Staffeln der 2. Bundesliga können sich alle Vereine bewerben, die die entsprechenden Kriterien erfüllen. Anträge müssen fristgerecht bei der Geschäftsstelle von Rugby Deutschland an office@rugbydeutschland.org eingereicht werden."
    },
    {
      "type": "paragraph",
      "content": "Weitere Informationen sowie alle zu erfüllenden Kriterien gibt es im entsprechenden Dokument zum Download."
    },
    {
      "type": "list",
      "items": [
        { "content": "Ausschreibung & Kriterien (PDF)", "url": "https://clubee-websites-prod.s3.eu-central-1.amazonaws.com/4253/files/application/4CH0XX4B3S9448PQWNE8WZXJVA.pdf" }
      ],
      "ordered": false
    }
  ]
};
